module.exports = __webpack_public_path__ + "img/enterprise_banner4_2.af7ca165.png";